// LIST
export const FETCH_ENQUIRIES = "app/Enquiries/FETCH_ENQUIRIES";
export const FETCH_ENQUIRIES_SUCCESS = "app/Enquiries/FETCH_ENQUIRIES_SUCCESS";
export const FETCH_ENQUIRIES_FAILURE = "app/Enquiries/FETCH_ENQUIRIES_FAILURE";
// GET VIEW DATA
export const GET_VIEW_DATA = "app/Enquiries/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Enquiries/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Enquiries/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_ENQUIRY = "app/Enquiries/ADD_ENQUIRY";
export const ADD_ENQUIRY_SUCCESS = "app/Enquiries/ADD_ENQUIRY_SUCCESS";
export const ADD_ENQUIRY_FAILURE = "app/Enquiries/ADD_ENQUIRY_FAILURE";
// EDIT
export const EDIT_ENQUIRY = "app/Enquiries/EDIT_ENQUIRY";
export const EDIT_ENQUIRY_SUCCESS = "app/Enquiries/EDIT_ENQUIRY_SUCCESS";
export const EDIT_ENQUIRY_FAILURE = "app/Enquiries/EDIT_ENQUIRY_FAILURE";
// DELETE
export const DELETE_ENQUIRY = "app/Enquiries/DELETE_ENQUIRY";
export const DELETE_ENQUIRY_SUCCESS = "app/Enquiries/DELETE_ENQUIRY_SUCCESS";
export const DELETE_ENQUIRY_FAILURE = "app/Enquiries/DELETE_ENQUIRY_FAILURE";
// DELETE NOTE
export const DELETE_ENQUIRY_NOTE = "app/Enquiries/DELETE_ENQUIRY_NOTE";
export const DELETE_ENQUIRY_NOTE_SUCCESS =
  "app/Enquiries/DELETE_ENQUIRY_NOTE_SUCCESS";
export const DELETE_ENQUIRY_NOTE_FAILURE =
  "app/Enquiries/DELETE_ENQUIRY_NOTE_FAILURE";
// DELETE ENQUIRY NOTE
export const DELETE_ENQUIRY_REMINDER_NOTE =
  "app/Enquiries/DELETE_ENQUIRY_REMINDER_NOTE";
export const DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS =
  "app/Enquiries/DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS";
export const DELETE_ENQUIRY_REMINDER_NOTE_FAILURE =
  "app/Enquiries/DELETE_ENQUIRY_REMINDER_NOTE_FAILURE";
//
export const OPEN_NOTE_ADD_MODAL = "app/Enquiries/OPEN_NOTE_ADD_MODAL";
export const CLOSE_NOTE_ADD_MODAL = "app/Enquiries/CLOSE_NOTE_ADD_MODAL";
//
export const OPEN_REMINDER_ADD_MODAL = "app/Enquiries/OPEN_REMINDER_ADD_MODAL";
export const CLOSE_REMINDER_ADD_MODAL =
  "app/Enquiries/CLOSE_REMINDER_ADD_MODAL";
// ADD
export const ADD_ENQUIRY_NOTE = "app/Enquiries/ADD_ENQUIRY_NOTE";
export const ADD_ENQUIRY_NOTE_SUCCESS =
  "app/Enquiries/ADD_ENQUIRY_NOTE_SUCCESS";
export const ADD_ENQUIRY_NOTE_FAILURE =
  "app/Enquiries/ADD_ENQUIRY_NOTE_FAILURE";
// LIST NOTES
export const FETCH_ENQUIRIES_NOTES = "app/Enquiries/FETCH_ENQUIRIES_NOTES";
export const FETCH_ENQUIRIES_NOTES_SUCCESS =
  "app/Enquiries/FETCH_ENQUIRIES_NOTES_SUCCESS";
export const FETCH_ENQUIRIES_NOTES_FAILURE =
  "app/Enquiries/FETCH_ENQUIRIES_NOTES_FAILURE";
// ADD ENQUIRY REMINDER
export const ADD_ENQUIRY_REMINDER = "app/Enquiries/ADD_ENQUIRY_REMINDER";
export const ADD_ENQUIRY_REMINDER_SUCCESS =
  "app/Enquiries/ADD_ENQUIRY_REMINDER_SUCCESS";
export const ADD_ENQUIRY_REMINDER_FAILURE =
  "app/Enquiries/ADD_ENQUIRY_REMINDER_FAILURE";
// LIST ENQUIRY NOTES
export const FETCH_ENQUIRIES_REMINDERS =
  "app/Enquiries/FETCH_ENQUIRIES_REMINDERS";
export const FETCH_ENQUIRIES_REMINDERS_SUCCESS =
  "app/Enquiries/FETCH_ENQUIRIES_REMINDERS_SUCCESS";
export const FETCH_ENQUIRIES_REMINDERS_FAILURE =
  "app/Enquiries/FETCH_ENQUIRIES_REMINDERS_FAILURE";
// EXPORT ENQUIRY
export const EXPORT_ENQUIRY = "app/Enquiries/EXPORT_ENQUIRY";
export const EXPORT_ENQUIRY_SUCCESS = "app/Enquiries/EXPORT_ENQUIRY_SUCCESS";
export const EXPORT_ENQUIRY_FAILURE = "app/Enquiries/EXPORT_ENQUIRY_FAILURE";
// EXPORT ENQUIRY
export const IMPORT_ENQUIRY = "app/Enquiries/IMPORT_ENQUIRY";
export const IMPORT_ENQUIRY_SUCCESS = "app/Enquiries/IMPORT_ENQUIRY_SUCCESS";
export const IMPORT_ENQUIRY_FAILURE = "app/Enquiries/IMPORT_ENQUIRY_FAILURE";
